export default __webpack_public_path__ + "static/media/nc.28aa894f.jpg";